import React from 'react'
import { css } from '@emotion/css'
import { CsCloseIcon } from '../icons'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { theme as deprecatedTheme } from '../../styled'

interface DetailTagsProps {
  readonly hasEditRole: boolean
  readonly tags: string[]
  readonly deleteTag: (tag: string) => void
}

export const tagTestId = 'tag-test-id'
export const closeIconTestId = 'close-icon-test-id'

export function DetailTags({ hasEditRole, tags, deleteTag }: DetailTagsProps) {
  return tags && tags.length > 0 ? (
    <div
      className={css`
        display: inline-flex;
        flex-flow: wrap;
        height: 33px;
        overflow: auto;
      `}
    >
      {tags.map((tag) => {
        return (
          <div
            data-testid={tagTestId}
            key={tag}
            className={css`
              white-space: nowrap;
              position: relative;
              margin: 5px 0px 5px 15px;
              display: inline-flex;
              height: 23px;
              border-radius: 0 3px 3px 0;
              padding: 0 8px 0 11px;
              background: ${theme.color.neutral30};
              color: ${theme.color.neutral70};
              line-height: 21px;
              font-size: 12px;
              cursor: default;
              pointer-events: none;
              top: -4px;
              pointer-events: unset;

              &:before {
                position: absolute;
                background: ${theme.color.neutral30};
                content: '\\25CF';
                color: white;
                text-shadow: 0 0 1px #aaa;
                font-size: 11px;
                line-height: 16px;
                text-indent: 5px;
                top: 3px;
                left: -8px;
                width: 16px;
                height: 17px;
                transform: rotate(43deg);
              }
            `}
          >
            <div
              className={css`
                max-width: 143px;
                overflow: hidden;
                text-overflow: ellipsis;
              `}
            >
              {tag}{' '}
            </div>
            <div
              className={css`
                padding-left: 4px;
              `}
            >
              {hasEditRole ? (
                <CsCloseIcon
                  data-testid={closeIconTestId}
                  className={css`
                    font-style: normal;

                    &:before {
                      font-weight: ${deprecatedTheme.fontWeights.primary.bold};
                      font-size: 8px;
                      cursor: pointer;
                      pointer-events: all;
                      color: ${theme.color.neutral70};
                    }

                    &:hover:before {
                      color: ${theme.color.neutral60};
                    }
                  `}
                  onClick={() => {
                    deleteTag(tag)
                  }}
                />
              ) : null}
            </div>
          </div>
        )
      })}
    </div>
  ) : (
    <></>
  )
}
